module.exports = __webpack_public_path__ + "img/bornutti9.56e75b63.jpg";